import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

export default function IosBtn() {
  const {i18n} = useTranslation();

  const langBtn = {
    de: require('../../../assets/images/consumer/appdownloadicons/btn_apple_deu.png'),
    en: require('../../../assets/images/consumer/appdownloadicons/btn_apple_en.svg'),
    es: require('../../../assets/images/consumer/appdownloadicons/btn_apple_es.png'),
    fr: require('../../../assets/images/consumer/appdownloadicons/btn_apple_fr.png'),
    ja: require('../../../assets/images/consumer/appdownloadicons/btn_apple_ja.png'),
    ko: require('../../../assets/images/consumer/appdownloadicons/btn_apple_kr.png'),
    pt: require('../../../assets/images/consumer/appdownloadicons/btn_apple_ptb.png'),
    it: require('../../../assets/images/consumer/appdownloadicons/btn_apple_ita.png'),
    tr: require('../../../assets/images/consumer/appdownloadicons/btn_apple_en.svg'),
    id: require('../../../assets/images/consumer/appdownloadicons/btn_apple_en.svg'),
    ru: require('../../../assets/images/consumer/appdownloadicons/btn_apple_en.svg'),
    th: require('../../../assets/images/consumer/appdownloadicons/btn_apple_en.svg'),
    gn: require('../../../assets/images/consumer/appdownloadicons/btn_apple_en.svg'),
    he: require('../../../assets/images/consumer/appdownloadicons/btn_apple_en.svg'),
    ar: require('../../../assets/images/consumer/appdownloadicons/btn_apple_en.svg'),
    pl: require('../../../assets/images/consumer/appdownloadicons/btn_apple_en.svg'),
    tl: require('../../../assets/images/consumer/appdownloadicons/btn_apple_en.svg'),
    ro: require('../../../assets/images/consumer/appdownloadicons/btn_apple_en.svg'),
    af: require('../../../assets/images/consumer/appdownloadicons/btn_apple_en.svg'),
    uk: require('../../../assets/images/consumer/appdownloadicons/btn_apple_en.svg'),
    el: require('../../../assets/images/consumer/appdownloadicons/btn_apple_en.svg'),
    sv: require('../../../assets/images/consumer/appdownloadicons/btn_apple_en.svg'),
    hu: require('../../../assets/images/consumer/appdownloadicons/btn_apple_en.svg'),
    bg: require('../../../assets/images/consumer/appdownloadicons/btn_apple_en.svg'),
    da: require('../../../assets/images/consumer/appdownloadicons/btn_apple_en.svg'),
    hr: require('../../../assets/images/consumer/appdownloadicons/btn_apple_en.svg'),
    vi: require('../../../assets/images/consumer/appdownloadicons/btn_apple_en.svg'),
    nl: require('../../../assets/images/consumer/appdownloadicons/btn_apple_en.svg'),
    zh_tw: require('../../../assets/images/consumer/appdownloadicons/btn_apple_ch.png'),
  };

  const [btn, setBtn] = useState(langBtn.en);

  useEffect(() => {
    if (
      i18n.language.toLowerCase() === 'zh-tw' ||
      i18n.language.toLowerCase() === 'zh_tw'
    ) {
      return setBtn(langBtn.zh_tw);
    }

    if (Object.keys(langBtn).includes(i18n.language)) {
      return setBtn(langBtn[i18n.language]);
    }
    setBtn(langBtn.en);
  }, [i18n.language]);

  return btn;
}
